import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./BinarySelectGroup.styled";
export const BinarySelectGroup = forwardRef(({ children, getNewSelection, isSelected, layout = "column", onChange = () => { }, ...otherProps }, ref) => (_jsx(Styled.BinarySelectGroup, { ref: ref, "data-testid": "BinarySelectGroup", layout: layout, ...otherProps, children: children({
        handleChange: (key, event) => {
            onChange && getNewSelection && onChange(getNewSelection(key), event);
        },
        isSelected
    }).map((child, index) => child && _jsx(Styled.BinarySelectGroupItem, { children: child }, index)) })));
BinarySelectGroup.displayName = "BinarySelectGroup";
